/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnumerationTrackItDataTypeFilterDto } from './EnumerationTrackItDataTypeFilterDto';
import {
    instanceOfEnumerationTrackItDataTypeFilterDto,
    EnumerationTrackItDataTypeFilterDtoFromJSON,
    EnumerationTrackItDataTypeFilterDtoFromJSONTyped,
    EnumerationTrackItDataTypeFilterDtoToJSON,
} from './EnumerationTrackItDataTypeFilterDto';

/**
 * @type CreateEnumerationEvaluationParameterDtoTrackItFilter
 * 
 * @export
 */
export type CreateEnumerationEvaluationParameterDtoTrackItFilter = EnumerationTrackItDataTypeFilterDto;


export function CreateEnumerationEvaluationParameterDtoTrackItFilterFromJSON(json: any): CreateEnumerationEvaluationParameterDtoTrackItFilter {
    return CreateEnumerationEvaluationParameterDtoTrackItFilterFromJSONTyped(json, false);
}

export function CreateEnumerationEvaluationParameterDtoTrackItFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEnumerationEvaluationParameterDtoTrackItFilter {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...EnumerationTrackItDataTypeFilterDtoFromJSONTyped(json, true) };
    return  EnumerationTrackItDataTypeFilterDtoFromJSONTyped(json, true);
}

export function CreateEnumerationEvaluationParameterDtoTrackItFilterToJSON(value?: CreateEnumerationEvaluationParameterDtoTrackItFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfEnumerationTrackItDataTypeFilterDto(value)) {
        return EnumerationTrackItDataTypeFilterDtoToJSON(value as EnumerationTrackItDataTypeFilterDto);
    }

    return {};
}

/**
 * Check if a given object implements the CreateEnumerationEvaluationParameterDtoTrackItFilter interface.
 */
export function instanceOfCreateEnumerationEvaluationParameterDtoTrackItFilter(value: any): value is CreateEnumerationEvaluationParameterDtoTrackItFilter {
    if (instanceOfEnumerationTrackItDataTypeFilterDto(value)) return true;
    return false;
}

